import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const TeamResourceActions = {
  associateResource: async (_, { teamId, resourceType, params }) => {
    return axiosRequest.
      post(`/teams/${teamId}/${resourceType}/permit_multi`, params).
      then(({ data }) => data).
      catch(handleError)
  },

  associateResourceToTeam: async (_, { teamId, resourceId, resourceType }) => {
    return axiosRequest.
      post(`/teams/${teamId}/${resourceType}/${resourceId}/permit`).
      then(({ data }) => data).
      catch(handleError)
  },

  excludeResourceFromTeam: async (_, { teamId, resourceId, resourceType }) => {
    return axiosRequest.
      delete(`/teams/${teamId}/${resourceType}/${resourceId}`).
      then(({ data }) => data).
      catch(handleError)
  },

  requestResourceAccess: async (_, { teamIds, entityType, entityId, message }) => {
    const params = {
      team_ids: teamIds,
      message: message,
      entity_id: entityId,
      entity_type: entityType,
    }

    return axiosRequest.
      post('/permissions/resources/access_request/create', params).
      then(({ data }) => data).
      catch(handleError)
  },

  verifyResourceAccess: async (_, {
    caseId,
    partyId,
    recordId,
  }) => {
    const params = {
      case_id: caseId,
      party_id: partyId,
      record_id: recordId,
    }

    return axiosRequest.
      post('/permissions/resources/access_request/verify_access', params).
      then(({ data }) => data).
      catch(handleError)
  },

  getTeamAccessRequests: async (_, { teamId }) => {
    return axiosRequest.
      get(`/teams/${teamId}/access_requests`).
      then(({ data }) => data).
      catch(handleError)
  },
}
